// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2f6Iz","top":"styles_top__EHjmP","left":"styles_left__3Dx2K","description":"styles_description__2QbLJ"};